import { APIProvider, Map } from '@vis.gl/react-google-maps';
import { MapOutline } from 'mdi-material-ui';
import { MuiButton } from '@/components/button/MuiButton';
import { useLogic } from './logic';
import { PublicHospitalMarker } from './PublicHospitalMarker';
import { HospitalListingOutput } from '@/helpers/parseHospitalListings';

type Props = {
  listings: HospitalListingOutput[];
  onToggleIsShowMap: () => void;
  mapMarkerPortalOfficeId?: number | null;
  onMarkerClick?: (listingId: number) => void;
};

export const PublicHospitalMap: React.FC<Props> = ({
  listings,
  onToggleIsShowMap,
  mapMarkerPortalOfficeId,
  onMarkerClick,
}) => {
  const { cameraProps, handleCameraChange } = useLogic({
    listings,
    mapMarkerPortalOfficeId,
  });

  return (
    <APIProvider apiKey={process.env.NEXT_PUBLIC_MAPS_API_KEY as string}>
      <MuiButton
        startIcon={<MapOutline />}
        onClick={onToggleIsShowMap}
        variant="contained"
        sx={{
          m: 0,
          maxHeight: 32,
          display: 'none',
          '@media (max-width: 800px)': {
            display: 'flex',
            margin: '0 auto',
            my: 2,
          },
        }}
      >
        Map表示
      </MuiButton>
      <Map
        {...cameraProps}
        onCameraChanged={handleCameraChange}
        mapId={'station-map'}
      >
        {listings.map((listing) => (
          <PublicHospitalMarker
            key={listing.id}
            listing={listing}
            mapMarkerPortalOfficeId={mapMarkerPortalOfficeId}
            onMarkerClick={onMarkerClick}
          />
        ))}
      </Map>
    </APIProvider>
  );
};
